module.exports = __webpack_public_path__ + "static/media/seife-savon-shampoo.04b7e280.png";